import React, { useRef } from 'react';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button } from '@dsi/react-eds';
import ErrorBoundary from '../../ErrorBoundary';
import { LogViewer, LogViewerSearch } from '@patternfly/react-log-viewer';
import './StepsLogView.css';
import { Toolbar, ToolbarContent, ToolbarItem } from '@patternfly/react-core';
import styles from '../PipelineDetail.module.css';

interface StepsLogViewProps {
  logs: string;
  isLoading: boolean;
  error: string | null;
  isStepCompletedButStageRunning: boolean;
  leftPanelOpen: boolean;
  theme: boolean;
}

const FooterButton: React.FC<{ logViewerRef: React.RefObject<unknown> }> = ({ logViewerRef }) => {
  const handleClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (logViewerRef as React.RefObject<any>)?.current?.scrollToBottom();
  };
  return (
    <ReactEDSWrapper component={Button} className="btn primary" onClick={handleClick}>
      Jump to the bottom
    </ReactEDSWrapper>
  );
};

const StepsLogView: React.FC<StepsLogViewProps> = ({
  logs,
  isLoading,
  error,
  isStepCompletedButStageRunning,
  leftPanelOpen,
  theme,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const logViewerRef = useRef<any>(null);

  const logData = isLoading
    ? 'Loading logs... Logs for this step will be available after the entire stage completes.'
    : error && isStepCompletedButStageRunning
      ? 'Loading logs... Logs for this step will be available after the entire stage completes.'
      : error
        ? error
        : logs
          ? logs
          : 'No logs available for this step.';

  return (
    <div
      id="pipelineStagesSteps"
      className={styles.logViewerContainer}
    >
      <ErrorBoundary>
        <LogViewer
          ref={logViewerRef}
          key={leftPanelOpen ? 'panel-open' : 'panel-closed'}
          theme={!theme ? 'dark' : 'light'}
          data={logData}
          width="100%"
          height="100%"
          hasLineNumbers
          isTextWrapped
          toolbar={
            <Toolbar>
              <ToolbarContent>
                <ToolbarItem>
                  <LogViewerSearch placeholder="Search ..." minSearchChars={1} />
                </ToolbarItem>
              </ToolbarContent>
            </Toolbar>
          }
          footer={<FooterButton logViewerRef={logViewerRef} />}
        />
      </ErrorBoundary>
    </div>
  );
};

export default StepsLogView;
